<div class="title-container d-flex align-items-center me-xl-0 py-1 px-3"
     [class.me-4]="isDetail()">
  <h4 class="title text-primary mb-0 flex-shrink-1">
    <ng-content select="[title]"></ng-content>
  </h4>
  <ng-content></ng-content>
  <div class="ms-auto flex-shrink-1 d-flex align-items-center">
    <ng-content select="[right]"></ng-content>
    <ng-content select="era-context-menu"></ng-content>
  </div>
</div>